import React from "react";
import PastorProfile from "../pastors/pastor-profile/PastorProfile";
import IdleWrapper from "../components/auth/IdleWrapper";

export default function PastorProfilePage() {
  return <IdleWrapper> <PastorProfile /> </IdleWrapper>;
}
